import React from 'react';

interface ICustomErrorProps {
  error: string;
}

const CustomError: React.FC<ICustomErrorProps> = ({ error }) => {
  return <div>{error}</div>;
};

export default CustomError;
